import React, {useEffect} from 'react'
import styled from 'styled-components'
import {getImageUrl} from "../../other/axios"

const Container = styled.div`
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.03);
    border-radius: 12px;
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    transition: all 0.3s ease;
    cursor: pointer;
    outline: none;

    &:hover, &:focus {
        background-color: rgba(0, 210, 255, 0.1);
        border-color: #00d2ff;
        transform: scale(1.01);
    }
`

const EpisodeImage = styled.img`
    width: 150px;
    height: 85px;
    object-fit: cover;
    border-radius: 8px;
    margin-right: 20px;
`

const EpisodeInfo = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
`

const Episode = ({episode, image, title, description, duration, selected, playEpisode}) => {
    
    const formatDuration = (seconds) => {
        if (!seconds) return "";
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        return h > 0 ? `${h}h ${m}m` : `${m} min`;
    }

    return (
        <Container tabIndex={0} onClick={() => playEpisode(episode)} className={selected ? "selected-ep" : ""}>
            <EpisodeImage src={getImageUrl(image)} alt={title} />
            <EpisodeInfo>
                <h4 style={{margin: 0, fontSize: '1rem', color: selected ? '#00d2ff' : '#fff'}}>
                    E{episode} - {title || `Episódio ${episode}`}
                </h4>
                <p style={{margin: '5px 0 0', fontSize: '0.8rem', color: 'rgba(255,255,255,0.5)', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical'}}>
                    {description || "Sem sinopse disponível."}
                </p>
                <span style={{fontSize: '0.7rem', color: '#00d2ff', marginTop: '5px'}}>{formatDuration(duration)}</span>
            </EpisodeInfo>
        </Container>
    )
}

export default Episode
